<template>
  <el-row class="ta-header">
    <div class="ta-chart-header ta-chart-header__with-hint">
      {{$t('charts.resourceFrequencies.title')}}
    </div>
    <div class="ta-chart-header ta-chart-header__small">
      {{$t('charts.resourceFrequencies.description')}}
    </div>
    <div v-if="dataAvailable">
      <div v-for='(result, index) in this.data.results' :key="'freq_' + result.label" :id="id+index"/>
    </div>
  </el-row>
</template>

<script>
import ChartMixin from './ChartMixin'
import Highcharts from 'highcharts'

export default {
  name: 'ResourceUsedFrequencies.vue',
  mixins: [ChartMixin],
  methods: {
    rerender () {
      for (let i = 0; i < this.numberOfBlades; i++) {
        this.$nextTick(() => {
          Highcharts.chart(this.id + i, {
            chart: {
              type: 'pie',
              backgroundColor: '#F1F6E4'
            },
            credits: {
              enabled: false
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: true,
                  format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                }
              }
            },
            title: {
              text: this.getTitle(i)
            },
            series: this.getSeries(i)
          })
        })
      }
    },
    dataMap (value) {
      return {
        name: this.labelMap(value),
        y: value.absoluteValue
      }
    },
    labelMap (value) {
      return this.$t('charts.labels.frequencies.' + value.label)
    },
    getTitle (bladeNumber) {
      return `${this.$t('charts.labels.blades.label')} ${bladeNumber + 1}`
    },
    dataAvailable () {
      return !!this.data.results
    },
    getBladeData (bladeNumber) {
      return this.data.results[bladeNumber].frequencyResult.damageList
    },
    filter () {
      return true
    },
    getSeries (bladeNumber) {
      const series = []
      const values = []
      this.iterate(bladeNumber, (f) => values.push(f))
      series.push({
        name: this.$t('charts.labels.blades.label') + ' ' + (bladeNumber + 1),
        colorByPoint: true,
        data: values.map(this.dataMap)
      })

      return series
    }
  }
}
</script>

<style scoped>

</style>
